import React, { useEffect, useState } from "react";
import SimpleBar from "simplebar-react";
import { useLocation } from "react-router-dom";
// import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IoIosArrowDown } from "react-icons/io";

import {
  faBook,
  faBoxOpen,
  faChartPie,
  faFlask,
  faFileAlt,
  faNotesMedical,
  faSignOutAlt,
  faTable,
  faTimes,
  faUsers,
  faMortarPestle,
  faMapPin,
  faInbox,
  faRocket,
  faClipboardList,
  faCertificate,
} from "@fortawesome/free-solid-svg-icons";
import {
  Nav,
  Badge,
  Image,
  Button,
  Dropdown,
  Accordion,
  Navbar,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";

import { Routes } from "../routes";
import ThemesbergLogo from "../assets/img/themesberg.svg";
import ReactHero from "../assets/img/technologies/react-hero-logo.svg";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";
import { BaseUrl } from "../Routes/BaseUrl";

export default (props = {}) => {
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const [category, setCategory] = useState([]);
  // const sidebarRef = useRef(null);
  const showClass = show ? "show" : "";

  const onCollapse = () => setShow(!show);


  const fetchCategory = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${BaseUrl.trim()}/admin/blog/getAll`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const json = await response.json();

      const uniqueCategory = [
        ...new Set(json?.data?.map((item) => item?.category)),
      ];

      setCategory(uniqueCategory);
    } catch (e) {
      console.log("error fetching category...", e);
    }
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  const CollapsableNavItem = (props) => {
    const { eventKey, title, icon, children = null } = props;
    const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";
    const [activeKey, setActiveKey] = useState(defaultKey);

    const handleSelect = (key) => {
      setActiveKey((prevKey) => (prevKey === key ? "" : key));
    };

    return (
      <Accordion
        as={Nav.Item}
        activeKey={activeKey}
        onSelect={handleSelect}
      >
        <Accordion.Item eventKey={eventKey}>
          <Accordion.Button
            as={Nav.Link}
            className="d-flex justify-content-between align-items-center"
          >
            <span>
              <span className="sidebar-icon">
                <FontAwesomeIcon icon={icon} />{" "}
              </span>
              <span className="sidebar-text">{title}</span>
            </span>
          </Accordion.Button>
          <Accordion.Body className="multi-level">
            <Nav className="flex-column">{children}</Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const NavItem = (props) => {
    const {
      title,
      link,
      external,
      target,
      icon,
      image,
      badgeText,
      badgeBg = "secondary",
      badgeColor = "primary",
      style,
    } = props;
    const classNames = badgeText
      ? "d-flex justify-content-start align-items-center justify-content-between"
      : "";
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName}>
        <Nav.Link {...linkProps} target={target} className={classNames}>
          <span className="d-flex align-items-center">
            {icon ? (
              <span className="sidebar-icon">
                <FontAwesomeIcon icon={icon} />{" "}
              </span>
            ) : null}
            {image ? (
              <Image
                src={image}
                width={40}
                height={40}
                className="sidebar-icon svg-icon"
              />
            ) : null}

            <span className="sidebar-text" style={style}>
              {title}
            </span>
          </span>
          {badgeText ? (
            <Badge
              pill
              bg={badgeBg}
              text={badgeColor}
              className="badge-md notification-count ms-2"
            >
              {badgeText}
            </Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  return (
    <>
      <Navbar
        expand={false}
        collapseOnSelect
        variant="dark"
        className="navbar-theme-primary px-4 d-md-none"
      >
        <Navbar.Brand
          className="me-lg-5"
          as={Link}
          to={Routes.DashboardOverview.path}
        >
          <Image src={ReactHero} className="navbar-brand-light" />
        </Navbar.Brand>
        <Navbar.Toggle
          as={Button}
          aria-controls="main-navbar"
          onClick={onCollapse}
        >
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <SimpleBar
        className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}
      >
        <div className="sidebar-inner px-4 pt-3">
          <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
            <div className="d-flex align-items-center">
              <div className="user-avatar lg-avatar me-4">
                <Image
                  src={ProfilePicture}
                  className="card-img-top rounded-circle border-white"
                />
              </div>
              <div className="d-block">
                <h6>Hi, Mohit</h6>
                <Button
                  as={Link}
                  variant="secondary"
                  size="xs"
                  to={Routes.Signin.path}
                  className="text-dark"
                >
                  <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />{" "}
                  Sign Out
                </Button>
              </div>
            </div>
            <Nav.Link
              className="collapse-close d-md-none"
              onClick={onCollapse}
            >
              <FontAwesomeIcon icon={faTimes} />
            </Nav.Link>
          </div>
          <Nav className="flex-column pt-3 pt-md-0">
            <NavItem
              title="avijo"
              // link={Routes.DashboardOverview.path}
              image={ReactHero}
              style={{ fontSize: "1.5rem" }}
            />
            <NavItem
              title="Overview"
              link={Routes.DashboardOverview.path}
              icon={faChartPie}
            />
            <CollapsableNavItem
              eventKey="user-management/"
              title="User Management"
              icon={faUsers}
            >
              <NavItem
                title="Patient"
                link={Routes.UserList.path}
                icon={faUsers}
              />
              <NavItem
                title="Doctor"
                link={Routes.DoctorList.path}
                icon={faNotesMedical}
              />
              <NavItem
                title="Facility"
                link={Routes.FacilityList.path}
                icon={faMapPin}
              />
            </CollapsableNavItem>
            <CollapsableNavItem
              eventKey="content/"
              title="Content"
              icon={faBook}
            >
              <NavItem
                title="Blogs"
                link={Routes.BlogList.path}
                icon={faFileAlt}
              />
              <NavItem
                title="Products"
                link={Routes.ProductList.path}
                icon={faBoxOpen}
              />
            </CollapsableNavItem>
            <NavItem
              title="Order Management"
              link={Routes.OrderManagement.path}
              icon={faClipboardList}
            />
            <NavItem
              title="Issue Certificate"
              link={Routes.IssueCertificate.path}
              icon={faCertificate}
            />
          </Nav>
        </div>
      </SimpleBar>
    </>
  );
};
